import React from "react";
import moment from "moment";
import { Collapse, Descriptions, Space } from "antd";
import { Couple } from "../../components";
import { useMediaQuery } from "react-responsive";
import { IFamilyTreePerson } from "../../interfaces";

export type DetailsTabPaneProps = {
  person: IFamilyTreePerson;
};

const DetailsTabPane: React.FC<DetailsTabPaneProps> = (props) => {
  const isSm = useMediaQuery({ query: "(max-width: 640px)" });
  return (
    <Collapse
      className="bg-transparent border-0 mt-2 mb-8"
      defaultActiveKey={["1", "2", "3"]}
    >
      <Collapse.Panel className="clear-collapse" header="Vitals" key="1">
        <Descriptions colon={true} layout="vertical">
          <Descriptions.Item className="font-bold" label="Name">
            {[
              props.person.first_name,
              props.person.middle_name,
              props.person.last_name,
            ].join(" ")}
          </Descriptions.Item>
          <Descriptions.Item className="font-bold" label="Sex">
            {props.person.gender}
          </Descriptions.Item>
          <Descriptions.Item className="font-bold" label="Birth">
            {moment(props.person.dob, "YYYY-MM-DD").format("DD/MM/YYYY")}
          </Descriptions.Item>
          <Descriptions.Item className="font-bold" label="Birthplace">
            {props.person.birthplace}
          </Descriptions.Item>
        </Descriptions>
      </Collapse.Panel>
      <Collapse.Panel
        className="clear-collapse"
        header="Other Information"
        key="2"
      >
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates
          non voluptatum odio omnis ut, dolore et laboriosam, eaque illo
          voluptatem, eum obcaecati? Reiciendis, dolore voluptatem voluptates
          vitae sunt excepturi iste.
        </p>
      </Collapse.Panel>
      <Collapse.Panel
        className="clear-collapse"
        header="Family Members"
        key="3"
      >
        <Space
          size="large"
          direction={isSm ? "vertical" : "horizontal"}
          className="w-full"
        >
          <Couple className="w-full" />
          <Couple className="w-full" />
        </Space>
      </Collapse.Panel>
    </Collapse>
  );
};

export default DetailsTabPane;
